import { render, staticRenderFns } from "./filterable-editor.vue?vue&type=template&id=10a6b080&scoped=true&"
import script from "./filterable-editor.vue?vue&type=script&lang=js&"
export * from "./filterable-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a6b080",
  null
  
)

export default component.exports